import { Nullable, WithErrors } from "../../types";
import { Symptoms, SymptomsDataFromAPI } from "./types";

export const convertSymptomsFromAPI = (
    dataFromAPI: Nullable<SymptomsDataFromAPI>
): Nullable<WithErrors<Symptoms>> => {
    return !dataFromAPI
        ? null
        : {
              type: dataFromAPI.type,
              rest_ecg: dataFromAPI.rest_ecg || [],
              exercise_ecg: dataFromAPI.exercise_ecg || [],
              all_ecg_types: dataFromAPI.all_ecg_types || [],
              recovery_ecg: dataFromAPI.recovery_ecg || [],
              rpeScale: dataFromAPI.rpe_scale,
              rpeValue: dataFromAPI.rpe_value,
          };
};

export const invertSymptomsData = (data: Symptoms): SymptomsDataFromAPI => {
    return {
        type: data.type,
        rest_ecg: data.rest_ecg,
        exercise_ecg: data.exercise_ecg,
        all_ecg_types: data.all_ecg_types,
        recovery_ecg: data.recovery_ecg,
        rpe_scale: data.rpeScale,
        rpe_value: data.rpeValue,
    };
};
